import React from 'react';
import { Box, Typography, Grid, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import './product_grid.scss';

interface ProductGridProps {
  category: string;
  search: string;
  onAddToCart: (product: Product) => void;
  onRemove: (product: Product) => void;
  cartItems: Product[];
  products: Product[];
}

interface Product {
  id: number;
  name: string;
  image: string;
  price: number;
  category: string;
  tags: string[]; 
  quantity?: number;
  originalPrice?: number;
  discountPercent?: number;
}

const ProductGrid: React.FC<ProductGridProps> = ({
  category,
  search,
  onAddToCart,
  onRemove,
  cartItems,
  products
}) => {
if (!products || products.length === 0) return null;


const filteredProducts = products.filter((product) => {
  return product.name.toLowerCase().includes(search.toLowerCase());
});


  const getCount = (productId: number) => {
    const item = cartItems.find((p) => p.id === productId);
    return item?.quantity || 0;
  };

  return (
    <Box mt={2}>
      <Grid container spacing={2}>
        {filteredProducts.map((product) => {
          const count = getCount(product.id);

          return (
          <Grid 
            item 
            xs={6}
            sm={6} 
            md={4} 
            lg={3}  
            key={product.id}
          >
            <Box className="product-card">
              <Box className="image-wrapper">
                {typeof product.discountPercent === 'number' && product.discountPercent > 0 && (
                  <Box className="discount-badge">{product.discountPercent}% off</Box>
                )}
                <img src={product.image} alt={product.name} className="product-image" />
                {count > 0 ? (
                  <Box className="product-controls-overlay added">
                    <IconButton size="small" onClick={() => onRemove(product)}>
                      <RemoveIcon fontSize="small" />
                    </IconButton>
                    <Typography className="product-qty">{count}</Typography>
                    <IconButton size="small" onClick={() => onAddToCart(product)}>
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ) : (
                  <Box className="add-button-overlay" onClick={() => onAddToCart(product)}>
                    ADD
                  </Box>
                )}
              </Box>
              <Box className="product-info">
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography className="product-price">₹ {product.price}</Typography>
                  {product.originalPrice && product.originalPrice > product.price && (
                    <Typography className="product-original-price">
                      ₹ {product.originalPrice}
                    </Typography>
                  )}
                </Box>
                <Typography className="product-name">{product.name}</Typography>
              </Box>
            </Box>
          </Grid>
        );
        })}
      </Grid>
    </Box>
  );
};

export default ProductGrid;

